import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import Immutable from 'immutable';
import classNames from 'classnames';
import moment from 'moment';
import localization from 'moment/locale/nl';
import { Route, Switch } from 'react-router';

import { EntityMapperContext, I18nProvider } from '@uncinc/react-drupal-core';
import { nl } from 'date-fns/locale';
import setDefaultOptions from 'date-fns/setDefaultOptions';

setDefaultOptions({ locale: nl });

import blocksMapper from '../../mappers/blocks';
import nodeMapper from '../../mappers/node';
import paragraphMapper from '../../mappers/paragraphs';
import taxonomyMapper from '../../mappers/taxonomy';
import viewsMapper from '../../mappers/views';

import {
  Navigation,
  Footer,
} from '../../implementations';

import {
  Container,
  Cookie,
} from '../../components';

import Entity from '../Entity';

import Search from '../Search';
import SearchMembers from '../SearchMembers';
import Pillar from '../Pillar';
import ThemeItem from '../../components/ThemeItem';
import Modal from '../../components/Modal';
import MenuSearchBar from '../../components/MenuSearchBar';

import '../../styles/main.scss';
import './style.scss';
import CustomRoute from '../CustomRoute/index';
import i18next from '../../config/i18next';

const entityTypeMapper = {
  block: blocksMapper,
  node: nodeMapper,
  paragraph: paragraphMapper,
  taxonomy: taxonomyMapper,
  view: viewsMapper,
};

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalVisible: false,
      showNavigation: true,
      searchbarVisible: false,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.modalContent !== this.props.modalContent) {
      this.setState({
        modalVisible: true,
      });
    }

    if (prevProps.nodeType !== this.props.nodeType && this.props.nodeType === 'jaaroverzicht') {
      this.setState({
        showNavigation: false,
      });
    }
  }

  componentWillUnmount() {
    clearTimeout(this.timer);
  }

  render() {

    moment.updateLocale('nl', localization);
    const {
      entity,
      modalContent,
      nodeType,
      childEntity,
      rootClasses,
      entityExists,
      language,
      pathname,
    } = this.props;

    const classes = classNames('App', rootClasses.join(' '), {
      'is-front-page': childEntity.get('is_front'),
      'not-found': !entityExists,
    });

    const isOnSearchPage = pathname.endsWith('/zoeken');

    const renderApp = () => {

      if (nodeType === 'jaaroverzicht') {
        const introTitle = entity.getIn(['title', 0, 'value']);
        const entityContent = modalContent ? entity.getIn(['field_paragraphs', modalContent.get('index'), 'entity'], Immutable.Map()) : null;
        return (
          <EntityMapperContext.Provider value={entityTypeMapper}>
            <Fragment>
              <Entity />
              <Modal visible={this.state.modalVisible} toggle={() => this.setState({ modalVisible: false })}>
                <ThemeItem introTitle={introTitle} entity={entityContent} />
              </Modal>
            </Fragment>
          </EntityMapperContext.Provider>
        );
      }

      return (
        <EntityMapperContext.Provider value={entityTypeMapper}>
          <I18nProvider locale={language} i18next={i18next}>
            <div key="header" className={classes} language={language}>
              <Container className="App--container">
                {(this.state.showNavigation) ?
                  <header className="header">
                    <Navigation
                      setSearchBarVisible={(val) => this.setState({ searchbarVisible: val })}
                      searchbarVisible={this.state.searchbarVisible}
                      isOnSearchPage={isOnSearchPage}
                    />
                  </header>
                  : null}
                {(this.state.searchbarVisible && !isOnSearchPage) && (
                  <MenuSearchBar
                    setSearchBarVisible={(val) => this.setState({ searchbarVisible: val })}
                  />
                )}
                <main className="main">
                  <div className="EntityPageWrapper">
                    <Switch>
                      <CustomRoute exact path="/:language/nbbu-in-de-zorg/:contentType" render={() => (<Pillar pillar="nbbu-in-de-zorg" />)} />
                      <CustomRoute exact path="/:language/uitzenden/:contentType" render={() => (<Pillar pillar="uitzenden" />)} />
                      <CustomRoute exact path="/:language/zzp-bemiddeling/:contentType" render={() => (<Pillar pillar="zzp-bemiddeling" />)} />
                      <CustomRoute exact path="/:language/payroll/:contentType" render={() => (<Pillar pillar="payroll" />)} />
                      <CustomRoute exact path="/:language/onze-leden" render={() => (<SearchMembers />)} />
                      <CustomRoute exact path="/onze-leden" render={() => (<SearchMembers />)} />
                      <CustomRoute exact path="/:language/zoeken" render={() => (<Search />)} />
                      <CustomRoute exact path="/zoeken" render={() => (<Search />)} />
                      <Route render={() => (<Entity />)} />
                    </Switch>
                  </div>
                  <Footer />
                </main>
              </Container>
              <Cookie />
              <div id="modal-root" />
            </div>
          </I18nProvider>
        </EntityMapperContext.Provider>
      );
    };

    return renderApp();
  }
}

function mapStateToProps(state, ownProps) {
  const entityType = ownProps.entityType || state.getIn(['entity', 'entityType'], null);
  const entityId = ownProps.entityId || state.getIn(['entity', 'entityId'], null);
  const entity = state.getIn([entityType, entityId], Immutable.Map());
  const modalContent = state.getIn(['modal', 'entity'], '');
  const pathname = state.getIn(['router', 'location', 'pathname'], '');

  return {
    entity: entity,
    modalContent,
    nodeType: state.getIn(['node', entityId, 'type', 0, 'target_id']),
    childEntity: ownProps.childEntity || state.getIn([entityType, entityId], Immutable.Map()),
    rootClasses: state.getIn(['ui', 'rootClasses']),
    entityExists: state.getIn(['entity', 'exists']),
    language: state.getIn(['ui', 'language']),
    pathname,
  };
}

export default connect(mapStateToProps)((App));
